var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer-wrap",attrs:{"height":"64","color":"primary lighten-1"}},[_c('frp-icon',{staticClass:"mr-8",attrs:{"src":"ico_bod-logo","color":_vm.colors.white.base}}),_vm._t("default"),_c('div')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }